import { render } from "./TourCard.vue?vue&type=template&id=cdc93d9a"
import script from "./TourCard.vue?vue&type=script&lang=js"
export * from "./TourCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__